module.exports = __webpack_public_path__ + "static/media/Pix-02.149b3974.svg";